<template lang="pug">
  b-row
    .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
      b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="changedPage")
    .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
      b-input-group(:prepend="$t('ui.page_size')" size="sm")
        b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
    .col-sm-12.col-md-12.col-lg-12.col-xl-12
      b-table#tblList.table-sm.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="list" :fields="fields" :per-page="perPage" :filter="filter")
        template(v-slot:cell(index)="row")
          span {{ row.index + 1 }}
        template(v-slot:cell(member_id)="row")
          b-link.text-uppercase(@click="redirectTo(row.item, 'gameResult')") #[b {{ row.item.member_id }}]
        template(v-slot:cell(bet_count)="row")
          span #[b {{ row.item.bet_count }}]
        template(v-slot:cell(turnover)="row")
          span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
        template(v-slot:cell(valid_turnover)="row")
          span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
        template(v-slot:cell(gross_comm)="row")
          span(:class="$helpers.getNumberClass(row.item.gross_comm)") #[b {{ row.item.gross_comm | currency }} ]
        template(v-slot:thead-top="row")
          tr
            th.bg-grey-lighter(colspan="6")
            template(v-for="level in downlineLevel")
              th.text-center(colspan="3" :class="'bg-grey-transparent-'+level" v-if="level==1") {{ $helpers.getUplineName(level) }}
            //- th.text-center.bg-grey-transparent-7(colspan="3") {{ $t("ui.company") }}
        template(v-slot:cell(member_winlose)="row")
          span(:class="$helpers.getNumberClass(row.item.member_winlose)") #[b {{ row.item.member_winlose | currency }} ]
        template(v-slot:cell(member_comm)="row")
          span(:class="$helpers.getNumberClass(row.item.member_comm)") #[b {{ row.item.member_comm | currency }} ]
        template(v-slot:cell(member_winlose_comm)="row")
          span(:class="$helpers.getNumberClass(row.item.member_winlose_comm)") #[b {{ row.item.member_winlose_comm | currency }} ]
        //- template(v-slot:cell(agent_winlose)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.agent_winlose)") #[b {{ row.item.agent_winlose | currency }} ]
        //- template(v-slot:cell(agent_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.agent_comm)") #[b {{ row.item.agent_comm | currency }} ]
        //- template(v-slot:cell(agent_winlose_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.agent_winlose_comm)") #[b {{ row.item.agent_winlose_comm | currency }} ]
        //- template(v-slot:cell(master_winlose)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.master_winlose)") #[b {{ row.item.master_winlose | currency }} ]
        //- template(v-slot:cell(master_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.master_comm)") #[b {{ row.item.master_comm | currency }} ]
        //- template(v-slot:cell(master_winlose_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.master_winlose_comm)") #[b {{ row.item.master_winlose_comm | currency }} ]
        //- template(v-slot:cell(senior_winlose)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.senior_winlose)") #[b {{ row.item.senior_winlose | currency }} ]
        //- template(v-slot:cell(senior_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.senior_comm)") #[b {{ row.item.senior_comm | currency }} ]
        //- template(v-slot:cell(senior_winlose_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.senior_winlose_comm)") #[b {{ row.item.senior_winlose_comm | currency }} ]
        //- template(v-slot:cell(s_senior_winlose)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.s_senior_winlose)") #[b {{ row.item.s_senior_winlose | currency }} ]
        //- template(v-slot:cell(s_senior_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.s_senior_comm)") #[b {{ row.item.s_senior_comm | currency }} ]
        //- template(v-slot:cell(s_senior_winlose_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.s_senior_winlose_comm)") #[b {{ row.item.s_senior_winlose_comm | currency }} ]
        //- template(v-slot:cell(shareholder_winlose)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.shareholder_winlose)") #[b {{ row.item.shareholder_winlose | currency }} ]
        //- template(v-slot:cell(shareholder_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.shareholder_comm)") #[b {{ row.item.shareholder_comm | currency }} ]
        //- template(v-slot:cell(shareholder_winlose_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.shareholder_winlose_comm)") #[b {{ row.item.shareholder_winlose_comm | currency }} ]
        //- template(v-slot:cell(company_winlose)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.company_winlose)") #[b {{ row.item.company_winlose | currency }} ]
        //- template(v-slot:cell(company_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.company_comm)") #[b {{ row.item.company_comm | currency }} ]
        //- template(v-slot:cell(company_winlose_comm)="row")
        //-   span(:class="$helpers.getNumberClass(row.item.company_winlose_comm)") #[b {{ row.item.company_winlose_comm | currency }} ]
        template(v-slot:bottom-row="row" v-if="list.length > 0")
          td.text-right(colspan="2")
            span #[b {{ $t("ui.sub_total") }} ]
            br
            span #[b {{ $t("ui.grand_total") }} ]
          td.text-center
            span #[b {{ subTotalBetCount }} ]
            br
            span #[b {{ grandTotalBetCount }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(subTotalTurnover)")  #[b {{ subTotalTurnover | currency }} ]
            br
            span(:class="$helpers.getNumberClass(grandTotalTurnover)")  #[b {{ grandTotalTurnover | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(subTotalValidTurnover)")  #[b {{ subTotalValidTurnover | currency }} ]
            br
            span(:class="$helpers.getNumberClass(grandTotalValidTurnover)")  #[b {{ grandTotalValidTurnover | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(subTotalGrossCommission)")  #[b {{ subTotalGrossCommission | currency }} ]
            br
            span(:class="$helpers.getNumberClass(grandTotalGrossCommission)")  #[b {{ grandTotalGrossCommission | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(subTotalMemberWinlose)")  #[b {{ subTotalMemberWinlose | currency }} ]
            br
            span(:class="$helpers.getNumberClass(grandTotalMemberWinlose)")  #[b {{ grandTotalMemberWinlose | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(subTotalMemberCommission)")  #[b {{ subTotalMemberCommission | currency }} ]
            br
            span(:class="$helpers.getNumberClass(grandTotalMemberCommission)")  #[b {{ grandTotalMemberCommission | currency }} ]
          td.text-right.bg-yellow-transparent-2
            span(:class="$helpers.getNumberClass(subTotalMemberWinloseCommission)")  #[b {{ subTotalMemberWinloseCommission | currency }} ]
            br
            span(:class="$helpers.getNumberClass(grandTotalMemberWinloseCommission)")  #[b {{ grandTotalMemberWinloseCommission | currency }} ]
          //- td.text-right
          //-   span(:class="$helpers.getNumberClass(subTotalAgentWinlose)") #[b {{ subTotalAgentWinlose | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalAgentWinlose)")  #[b {{ grandTotalAgentWinlose | currency }} ]
          //- td.text-right
          //-   span(:class="$helpers.getNumberClass(subTotalAgentCommission)") #[b {{ subTotalAgentCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalAgentCommission)")  #[b {{ grandTotalAgentCommission | currency }} ]
          //- td.text-right.bg-yellow-transparent-2
          //-   span(:class="$helpers.getNumberClass(subTotalAgentWinloseCommission)") #[b {{ subTotalAgentWinloseCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalAgentWinloseCommission)")  #[b {{ grandTotalAgentWinloseCommission | currency }} ]
          //- td.text-right(:class="show(3)")
          //-   span(:class="$helpers.getNumberClass(subTotalMasterWinlose)") #[b {{ subTotalMasterWinlose | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalMasterWinlose)")  #[b {{ grandTotalMasterWinlose | currency }} ]
          //- td.text-right(:class="show(3)")
          //-   span(:class="$helpers.getNumberClass(subTotalMasterCommission)") #[b {{ subTotalMasterCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalMasterCommission)")  #[b {{ grandTotalMasterCommission | currency }} ]
          //- td.text-right.bg-yellow-transparent-2(:class="show(3)")
          //-   span(:class="$helpers.getNumberClass(subTotalMasterWinloseCommission)") #[b {{ subTotalMasterWinloseCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalMasterWinloseCommission)")  #[b {{ grandTotalMasterWinloseCommission | currency }} ]
          //- td.text-right(:class="show(4)")
          //-   span(:class="$helpers.getNumberClass(subTotalSeniorWinlose)") #[b {{ subTotalSeniorWinlose | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalSeniorWinlose)")  #[b {{ grandTotalSeniorWinlose | currency }} ]
          //- td.text-right(:class="show(4)")
          //-   span(:class="$helpers.getNumberClass(subTotalSeniorCommission)") #[b {{ subTotalSeniorCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalSeniorCommission)")  #[b {{ grandTotalSeniorCommission | currency }} ]
          //- td.text-right.bg-yellow-transparent-2(:class="show(4)")
          //-   span(:class="$helpers.getNumberClass(subTotalSeniorWinloseCommission)") #[b {{ subTotalSeniorWinloseCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalSeniorWinloseCommission)")  #[b {{ grandTotalSeniorWinloseCommission | currency }} ]
          //- td.text-right(:class="show(5)")
          //-   span(:class="$helpers.getNumberClass(subTotalSuperSeniorWinlose)") #[b {{ subTotalSuperSeniorWinlose | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalSuperSeniorWinlose)")  #[b {{ grandTotalSuperSeniorWinlose | currency }} ]
          //- td.text-right(:class="show(5)")
          //-   span(:class="$helpers.getNumberClass(subTotalSuperSeniorCommission)") #[b {{ subTotalSuperSeniorCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalSuperSeniorCommission)")  #[b {{ grandTotalSuperSeniorCommission | currency }} ]
          //- td.text-right.bg-yellow-transparent-2(:class="show(5)")
          //-   span(:class="$helpers.getNumberClass(subTotalSuperSeniorWinloseCommission)") #[b {{ subTotalSuperSeniorWinloseCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalSuperSeniorWinloseCommission)")  #[b {{ grandTotalSuperSeniorWinloseCommission | currency }} ]
          //- td.text-right(:class="show(6)")
          //-   span(:class="$helpers.getNumberClass(subTotalShareholderWinlose)") #[b {{ subTotalShareholderWinlose | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalShareholderWinlose)")  #[b {{ grandTotalShareholderWinlose | currency }} ]
          //- td.text-right(:class="show(6)")
          //-   span(:class="$helpers.getNumberClass(subTotalShareholderCommission)") #[b {{ subTotalShareholderCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalShareholderCommission)")  #[b {{ grandTotalShareholderCommission | currency }} ]
          //- td.text-right.bg-yellow-transparent-2(:class="show(6)")
          //-   span(:class="$helpers.getNumberClass(subTotalShareholderWinloseCommission)") #[b {{ subTotalShareholderWinloseCommission | currency }}]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalShareholderWinloseCommission)")  #[b {{ grandTotalShareholderWinloseCommission | currency }} ]
          //- td.text-right
          //-   span(:class="$helpers.getNumberClass(subTotalCompanyWinlose)")  #[b {{ subTotalCompanyWinlose | currency }} ]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalCompanyWinlose)")  #[b {{ grandTotalCompanyWinlose | currency }} ]
          //- td.text-right
          //-   span(:class="$helpers.getNumberClass(subTotalCompanyCommission)")  #[b {{ subTotalCompanyCommission | currency }} ]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalCompanyCommission)")  #[b {{ grandTotalCompanyCommission | currency }} ]
          //- td.text-right.bg-yellow-transparent-2
          //-   span(:class="$helpers.getNumberClass(subTotalCompanyWinloseCommission)")  #[b {{ subTotalCompanyWinloseCommission | currency }} ]
          //-   br
          //-   span(:class="$helpers.getNumberClass(grandTotalCompanyWinloseCommission)")  #[b {{ grandTotalCompanyWinloseCommission | currency }} ]
</template>

<script>

export default {
  props: {
    list: {
      type: Array,
      default: function () { return [] }
    },
    total: {
      type: Array,
      default: function () { return [] }
    },
    totalRows: 0
  },
  data() {
    return {
      downlineLevel: this.$store.getters.accountType,
      filter: null,
      sortBy: "member_id",
      sortDesc: false,
      currentPage: 1
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_count",
          label: this.$t("ui.bet_count"),
          class: "align-middle text-center",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "turnover",
          label: this.$t("ui.turnover"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "valid_turnover",
          label: this.$t("ui.valid_turnover"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "gross_comm",
          label: this.$t("ui.gross_commission"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_winlose",
          label: this.$t("ui.winlose_column1"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_comm",
          label: this.$t("ui.winlose_column2"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_winlose_comm",
          label: this.$t("ui.total"),
          // sortable: true,
          class: "align-middle text-right bg-yellow-transparent-2",
          thClass: "bg-yellow-transparent-2",
          thStyle: {
            width: "7%"
          }
        },
        // {
        //   key: "agent_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   // sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "agent_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   // sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "agent_winlose_comm",
        //   label: this.$t("ui.total"),
        //   // sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2",
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "master_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(3),
        //   thClass: "bg-grey-transparent-3",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "master_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(3),
        //   thClass: "bg-grey-transparent-3",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "master_winlose_comm",
        //   label: this.$t("ui.total"),
        //   // sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2 " + this.show(3),
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "senior_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(4),
        //   thClass: "bg-grey-transparent-4",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "senior_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(4),
        //   thClass: "bg-grey-transparent-4",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "senior_winlose_comm",
        //   label: this.$t("ui.total"),
        //   // sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2 " + this.show(4),
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "s_senior_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(5),
        //   thClass: "bg-grey-transparent-5",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "s_senior_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(5),
        //   thClass: "bg-grey-transparent-5",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "s_senior_winlose_comm",
        //   label: this.$t("ui.total"),
        //   // sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2 " + this.show(5),
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "shareholder_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(6),
        //   thClass: "bg-grey-transparent-6",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "shareholder_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   // sortable: true,
        //   class: "align-middle text-right " + this.show(6),
        //   thClass: "bg-grey-transparent-6",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "shareholder_winlose_comm",
        //   label: this.$t("ui.total"),
        //   // sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2 " + this.show(6),
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "company_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   // sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-7",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "company_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   // sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "bg-grey-transparent-7",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "company_winlose_comm",
        //   label: this.$t("ui.total"),
        //   // sortable: true,
        //   class: "align-middle text-right bg-yellow-transparent-2",
        //   thClass: "bg-yellow-transparent-2",
        //   thStyle: {
        //     width: "7%"
        //   }
        // }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    pageDetail() {
      return this.$store.getters.getPageDetail
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    subTotalBetCount() {
      return this.sumSubTotal("bet_count")
    },
    subTotalTurnover() {
      return this.sumSubTotal("turnover")
    },
    subTotalValidTurnover() {
      return this.sumSubTotal("valid_turnover")
    },
    subTotalGrossCommission() {
      return this.sumSubTotal("gross_comm")
    },
    subTotalMemberWinlose() {
      return this.sumSubTotal("member_winlose")
    },
    subTotalMemberCommission() {
      return this.sumSubTotal("member_comm")
    },
    subTotalMemberWinloseCommission() {
      return this.sumSubTotal("member_winlose_comm")
    },
    subTotalAgentWinlose() {
      return this.sumSubTotal("agent_winlose")
    },
    subTotalAgentCommission() {
      return this.sumSubTotal("agent_comm")
    },
    subTotalAgentWinloseCommission() {
      return this.sumSubTotal("agent_winlose_comm")
    },
    subTotalMasterWinlose() {
      return this.sumSubTotal("master_winlose")
    },
    subTotalMasterCommission() {
      return this.sumSubTotal("master_comm")
    },
    subTotalMasterWinloseCommission() {
      return this.sumSubTotal("master_winlose_comm")
    },
    subTotalSeniorWinlose() {
      return this.sumSubTotal("senior_winlose")
    },
    subTotalSeniorCommission() {
      return this.sumSubTotal("senior_comm")
    },
    subTotalSeniorWinloseCommission() {
      return this.sumSubTotal("senior_winlose_comm")
    },
    subTotalSuperSeniorWinlose() {
      return this.sumSubTotal("s_senior_winlose")
    },
    subTotalSuperSeniorCommission() {
      return this.sumSubTotal("s_senior_comm")
    },
    subTotalSuperSeniorWinloseCommission() {
      return this.sumSubTotal("s_senior_winlose_comm")
    },
    subTotalShareholderWinlose() {
      return this.sumSubTotal("shareholder_winlose")
    },
    subTotalShareholderCommission() {
      return this.sumSubTotal("shareholder_comm")
    },
    subTotalShareholderWinloseCommission() {
      return this.sumSubTotal("shareholder_winlose_comm")
    },
    subTotalCompanyWinlose() {
      return this.sumSubTotal("company_winlose")
    },
    subTotalCompanyCommission() {
      return this.sumSubTotal("company_comm")
    },
    subTotalCompanyWinloseCommission() {
      return this.sumSubTotal("company_winlose_comm")
    },
    grandTotalBetCount() {
      return this.sumGrandTotal("bet_count")
    },
    grandTotalTurnover() {
      return this.sumGrandTotal("turnover")
    },
    grandTotalValidTurnover() {
      return this.sumGrandTotal("valid_turnover")
    },
    grandTotalGrossCommission() {
      return this.sumGrandTotal("gross_comm")
    },
    grandTotalMemberWinlose() {
      return this.sumGrandTotal("member_winlose")
    },
    grandTotalMemberCommission() {
      return this.sumGrandTotal("member_comm")
    },
    grandTotalMemberWinloseCommission() {
      return this.sumGrandTotal("member_winlose_comm")
    },
    grandTotalAgentWinlose() {
      return this.sumGrandTotal("agent_winlose")
    },
    grandTotalAgentCommission() {
      return this.sumGrandTotal("agent_comm")
    },
    grandTotalAgentWinloseCommission() {
      return this.sumGrandTotal("agent_winlose_comm")
    },
    grandTotalMasterWinlose() {
      return this.sumGrandTotal("master_winlose")
    },
    grandTotalMasterCommission() {
      return this.sumGrandTotal("master_comm")
    },
    grandTotalMasterWinloseCommission() {
      return this.sumGrandTotal("master_winlose_comm")
    },
    grandTotalSeniorWinlose() {
      return this.sumGrandTotal("senior_winlose")
    },
    grandTotalSeniorCommission() {
      return this.sumGrandTotal("senior_comm")
    },
    grandTotalSeniorWinloseCommission() {
      return this.sumGrandTotal("senior_winlose_comm")
    },
    grandTotalSuperSeniorWinlose() {
      return this.sumGrandTotal("s_senior_winlose")
    },
    grandTotalSuperSeniorCommission() {
      return this.sumGrandTotal("s_senior_comm")
    },
    grandTotalSuperSeniorWinloseCommission() {
      return this.sumGrandTotal("s_senior_winlose_comm")
    },
    grandTotalShareholderWinlose() {
      return this.sumGrandTotal("shareholder_winlose")
    },
    grandTotalShareholderCommission() {
      return this.sumGrandTotal("shareholder_comm")
    },
    grandTotalShareholderWinloseCommission() {
      return this.sumGrandTotal("shareholder_winlose_comm")
    },
    grandTotalCompanyWinlose() {
      return this.sumGrandTotal("company_winlose")
    },
    grandTotalCompanyCommission() {
      return this.sumGrandTotal("company_comm")
    },
    grandTotalCompanyWinloseCommission() {
      return this.sumGrandTotal("company_winlose_comm")
    }
  },
  methods: {
    show: function(level) {
      return this.downlineLevel >= level ? '' : 'd-none'
    },
    sumSubTotal: function(item) {
      let sum = 0
      if(this.list.length > 0) {
        this.list.forEach(value => {
          sum = sum + value[item];
        })
      }
      return sum
    },
    sumGrandTotal: function(item) {
      let sum = 0
      if(this.total.length > 0) {
        sum = this.total[0][item]
      }
      return sum
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo
      let page = {
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: "member_id",
        direction: this.direction
      }
      this.$store.dispatch("layout/setPageDetail", page)
      this.$emit("refresh")
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      let page = {
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: "member_id",
        direction: this.direction
      }
      this.$store.dispatch("layout/setPageDetail", page)
      this.$emit("refresh")
    },
    redirectTo: function(account, url) {
      let page = {
        currentPage: 1,
        perPage: this.perPage,
        sortBy: "",
        direction: this.direction
      }
      this.$store.dispatch("layout/setPageDetail", page)
      this.$store.dispatch("user/setSelectedID", account.member_id);
      this.$router.push("/" + url)
    }
  }
}

</script>